<template>
  <table>
    <thead>
      <tr class="level-one-header">
        <th colspan="6">Sample Information</th>
        <th colspan="17">ASTM D5185 Wear Metals by ICP-OES (ppm)</th>
      </tr>
      <tr class="level-two-header">
        <th>Lab ID</th>
        <th>{{ sampleData.currentOilSample.makeUpOilUnitOfMeasureName }}</th>
        <th>{{ sampleData.currentOilSample.milesOrHoursOnSampleUnitOfMeasureName }}</th>
        <th>Meter</th>
        <th>Date Received</th>
        <th>Date Sampled</th>
        <th
          v-for="{ abbreviation } in elementList"
          class="sample-element"
          :key="`${abbreviation} Header`"
        >
          {{ abbreviation }}
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(sample, index) in sampleData.oilSamples">
        <tr :key="`Primary Table Sample ${index}`">
          <td class="sample-number">{{ sample.sampleNumber }}</td>
          <td>{{ sample.makeUpOil }}</td>
          <td>{{ sample.milesOrHoursOnSample }}</td>
          <td>{{ sample.meterReading }}</td>
          <td>{{ sample.dateReceived | formatTime }}</td>
          <td>{{ sample.dateSampled | formatTime }}</td>
          <td :class="`severity-id-${sample.copperSeverity}`">{{ sample.copper }}</td>
          <td :class="`severity-id-${sample.ironSeverity}`">{{ sample.iron }}</td>
          <td :class="`severity-id-${sample.chromiumSeverity}`">{{ sample.chromium }}</td>
          <td :class="`severity-id-${sample.aluminumSeverity}`">{{ sample.aluminum }}</td>
          <td :class="`severity-id-${sample.leadSeverity}`">{{ sample.lead }}</td>
          <td :class="`severity-id-${sample.tinSeverity}`">{{ sample.tin }}</td>
          <td :class="`severity-id-${sample.siliconSeverity}`">{{ sample.silicon }}</td>
          <td :class="`severity-id-${sample.calciumSeverity}`">{{ sample.calcium }}</td>
          <td :class="`severity-id-${sample.magnesiumSeverity}`">{{ sample.magnesium }}</td>
          <td :class="`severity-id-${sample.zincSeverity}`">{{ sample.zinc }}</td>
          <td :class="`severity-id-${sample.phosphorousSeverity}`">
            {{ sample.phosphorous }}
          </td>
          <td :class="`severity-id-${sample.molybdenumSeverity}`">
            {{ sample.molybdenum }}
          </td>
          <td :class="`severity-id-${sample.boronSeverity}`">{{ sample.boron }}</td>
          <td :class="`severity-id-${sample.silverSeverity}`">{{ sample.silver }}</td>
          <td :class="`severity-id-${sample.nickelSeverity}`">{{ sample.nickel }}</td>
          <td :class="`severity-id-${sample.sodiumSeverity}`">{{ sample.sodium }}</td>
          <td :class="`severity-id-${sample.potassiumSeverity}`">{{ sample.potassium }}</td>
        </tr>
        <tr :key="index">
          <td colspan="3" class="no-center align-top">
            <span class="bold">Job ID:</span> {{ sample.jobNumber }}
          </td>
          <td colspan="20" class="no-center">
            <span class="bold">Comments:</span>
            <span v-html="$options.filters.formatComment(sample.comments, index)"></span>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Constants from '../../../constants/constants';

export default {
  name: 'OilSampleReportSampleInfoMetals',
  filters: {
    formatTime(value) {
      if (!value) {
        return;
      }

      return value.split('T')[0];
    },

    formatComment(comment, index) {
      if (comment && index >= Constants.SampleReport.comment.count) {
        return comment
          .slice(0, Constants.SampleReport.comment.cutoff)
          .trim()
          .concat(Constants.SampleReport.comment.overflowText);
      }

      return comment;
    }
  },
  props: {
    sampleData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      elementList: Constants.SampleReport.Element.oilSampleElements
    };
  }
};
</script>
